const API_BASE_URL = 'https://api-ph.gnpmasivos.com/api';
//const API_BASE_URL = 'https://api-ph-dev.gnpmasivos.com/api';

const SYSTEM_EMAIL = 'api@ph-gnp.com';
const SYSTEM_PASSWORD = 'password@123';

const getToken = () => localStorage.getItem('auth_token');
const setToken = (token) => localStorage.setItem('auth_token', token);
export const clearAuth = () => {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('user');
};

const handleResponse = async (response) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    if (response.status === 401) throw new Error('UNAUTHORIZED');
    
    const message = data.message || 'Error en la petición';
    throw new Error(message);
  }
  return data;
};

let authPromise = null;

export const ensureAuth = async (forceLogin = false) => {
  let token = getToken();

  if (token && !forceLogin) {
    return { token };
  }

  if (authPromise) {
    return authPromise;
  }

  authPromise = login(SYSTEM_EMAIL, SYSTEM_PASSWORD)
    .then((response) => {
      const newToken = response.token || response.access_token;
      if (!newToken) throw new Error('No se obtuvo token del servidor');
      return { token: newToken };
    })
    .catch((error) => {
      clearAuth();
      throw error;
    })
    .finally(() => {
      authPromise = null; 
    });

  return authPromise;
};

export const apiRequest = async (endpoint, options = {}) => {
  try {
    const { token } = await ensureAuth();

    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`,
      ...options.headers,
    };

    let response = await fetch(`${API_BASE_URL}${endpoint}`, {
      ...options,
      headers,
    });

    if (response.status === 401) {
      const { token: newToken } = await ensureAuth(true);
      
      headers['Authorization'] = `Bearer ${newToken}`;
      response = await fetch(`${API_BASE_URL}${endpoint}`, {
        ...options,
        headers,
      });
    }

    return await handleResponse(response);
  } catch (error) {
    if (error.message === 'UNAUTHORIZED') {
      clearAuth();
    }
    throw error;
  }
};

export const login = async (email, password) => {
  const response = await fetch(`${API_BASE_URL}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || 'Error de autenticación');
  }

  const data = await response.json();
  const token = data.token || data.access_token;
  if (token) setToken(token);

  localStorage.setItem('user', JSON.stringify({ email }));
  return data;
};

export const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

export const isAuthenticated = () => {
  return !!getToken();
};